import { DefensesWidget } from "./DefensesWidget";

export default DefensesWidget;
